module.exports = __webpack_public_path__ + "public/img/no-clients.f147605.png";